import React from 'react'

const Layout = React.lazy(() => import('./Layout'))
const DefaultPage = React.lazy(() => import('./DefaultPage'))
const Show = React.lazy(() => import('./Show'))

export default {
  path: '/:channel/food-journal',
  name: 'Food journal',
  component: Layout,
  protected: true,
  childRoutes: [
    { path: 'default-page', name: 'Default page', component: DefaultPage, isIndex: true },
    { path: 'show/:id', name: 'Show', component: Show },
  ],
};



// WEBPACK FOOTER //
// ./src/features/food-journal/route.js